import { Role } from "../common";

export const getRoleColor = function (role: Role): string {
	switch (role) {
		case Role.Admin:
			return "#3fb950";
		case Role.Moderator:
			return "#a371f7";
		default:
			return "#58a6ff";
	}
};
